import React from "react";
import Counter from "../../../../shared-components/counter";

const TopCounter = ({ endDateTime }: { endDateTime: string }) => {
  return (
    <Counter
      EndDateTime={new Date(endDateTime)}
      textClass={`text-[#BCBCC0] text-xs font-normal leading-4 lg:text-base lg:leading-6`}
      numericClass="text-primary text-xs font-medium leading-4 lg:text-base lg:leading-6 self-end"
      containerClass="flex items-center justify-center bg-black px-2.5 gap-2 min-h-6 lg:min-h-12"
      format="d:h:m:s"
    />
  );
};

export default TopCounter;
